import Cookies from 'js-cookie';
import configuration from '../configs/IConfiguration';
import CryptoJS from 'crypto-js';
import authService from '../security/IAuthService';

class CookieService {
    setCookie = (cookieName: string, cookieValue: string) => {
        const auth = authService.getCachedAuth();
        if (!!auth) {
            const secretKey = auth.publicKey;
            const encryptedValue = CryptoJS.AES.encrypt(cookieValue, secretKey).toString();
            Cookies.set(this.getCookieFullname(cookieName), encryptedValue, this.getCookieConfiguration());
        } else {
            throw new Error('Auth is not cached');
        }
    };

    getCookie = (cookieName: string) => {
        let cookieValue: string | undefined;
        const auth = authService.getCachedAuth();
        if (!!auth) {
            try {
                const encryptedValue = Cookies.get(this.getCookieFullname(cookieName));
                const secretKey = auth.publicKey;
                if (!!encryptedValue) {
                    const decryptedValue = CryptoJS.AES.decrypt(encryptedValue, secretKey);
                    cookieValue = decryptedValue.toString(CryptoJS.enc.Utf8);
                }
            } catch (error) {
                this.removeCookie(cookieName);
            }
        } else {
            throw new Error('Auth is not cached');
        }

        return cookieValue;
    };

    removeCookie = (cookieName: string) => {
        Cookies.remove(this.getCookieFullname(cookieName), this.getCookieConfiguration());
    };

    /**
     * Returns a cookie full name with the domain string of the current configuration
     * @param name cookie name initial text
     * @returns the cookie full name
     */
    private getCookieFullname = (name: string): string => {
        return name + configuration.getCookiesSubfix();
    };

    /**
     * Returns the cookie configuration
     * @returns the cookie configuration
     */
    private getCookieConfiguration = (): Cookies.CookieAttributes => {
        return {
            domain: configuration.getParentDomain(),
            secure: window.location.protocol === 'https:',
            sameSite: 'Strict',
            path: '/',
        };
    };
}

const cookieService: CookieService = new CookieService();
export default cookieService;
